module.exports = __webpack_public_path__ + "img/jszg.38e6b564.png";